import { GLOBAL_SEARCH_PRODUCTS } from "../../types/ProductType";
import axios from "axios";

const globalSearchAction = (data) => {
  return {
    type: GLOBAL_SEARCH_PRODUCTS,
    payload: data,
  };
};

export const globalProductSearch = (searchTerm, page = 1, limit = 1000, options = {}) => {
  const onlyLedger =
    options.onlyLedgerStock === true || options.onlyLedgerStock === "true";
  return async (dispatch) => {
    try {
      let url = `product?query=search&prod=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`;
      if (onlyLedger) url += `&only_ledger_stock=1`;
      const { data } = await axios.get(url);

      // Normalize to array: support { data: [...] } or { data: [...], pagination } or raw array
      const searchResults = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data)
          ? data
          : [];

      dispatch(globalSearchAction(searchResults));
      return { status: "success", data: searchResults };
    } catch (error) {
      console.log(error.message);
      return { status: "error", error: error.message };
    }
  };
};
